import { useTranslation } from '@frontend/i18n';
import { Text, TextLink } from '@frontend/design-system';
import { WEAVE_HELP_URLS } from '../../constants';

export const TextConnectSettingsSubtitle = () => {
  const { t } = useTranslation('schedule-settings');

  return (
    <div css={{ maxWidth: '660px' }}>
      <Text as='span'>
        {t(
          'Text Connect allows you to add a text messaging option for customers on your website or other online platforms. Need help setting up Text Connect? Visit our'
        )}
      </Text>{' '}
      <TextLink size='large' to={WEAVE_HELP_URLS.INSTALL_TEXT_CONNECT} target='_blank'>
        {t('help center')}
      </TextLink>{' '}
      <Text as='span'>{t('for step-by-step instructions')}</Text>
    </div>
  );
};
